import { __decorate, __metadata } from "tslib";
import { IsNumber, IsOptional, IsUUID, Min } from 'class-validator';
import { LineItemType } from '../../type/order';
import { PriceCalculationParams } from './PriceCalculationParams';
/**
 * Params to use when calculating the price of a transcript line item
 */
export class TranscriptPriceCalculationParams extends PriceCalculationParams {
    /**
     * @param timeRanges The time ranges to derive the request duration from when calculating a per-minute rate
     * @param turnaroundId Identifies the turnaround the transcript must be delivered in
     * @param paperCopies The number of transcript paper copies to be produced
     */
    constructor(timeRanges, turnaroundId, paperCopies) {
        super(timeRanges);
        this.type = LineItemType.CertifiedTranscript;
        this.turnaroundId = turnaroundId;
        this.paperCopies = paperCopies;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], TranscriptPriceCalculationParams.prototype, "turnaroundId", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], TranscriptPriceCalculationParams.prototype, "paperCopies", void 0);
